import Vue from 'vue'
//import VueRouter from 'vue-router'
import router from './router'
import { store } from './store/store'
import App from './App.vue'
//import $ from 'jquery'
import 'bootstrap'
//import WelcomePanel from './components/welcome-panel'
//import SettingsPage from './components/settings-page'
import ReceivedFilesPanel from './components/user/received-files-panel'
//import ReceivedFilesPage from './components/received-files-page'
//import UploadFilePage from './components/upload-file-page'
import './styles/style.scss'
import './fontawesome'
import './scripts/smartwizard'

//Add master layout components
const requireComponent = require.context(
  './components/master',
  true,
  /\w+\.(vue|js)$/
)

requireComponent.keys().forEach(fileName => {
  const componentConfig = requireComponent(fileName)
  const componentName =
    fileName
      .split('/')
      .pop()
      .replace(/\.\w+$/, '')

  Vue.component(
    componentName,
    componentConfig.default || componentConfig
  )
});

//Initialise App
new Vue({
   el: '#app',
   router,
   store,
   render: h => h(App),
   components: {
     //'welcome-panel' : WelcomePanel,
     //'settings-page' : SettingsPage,
     //'received-files-panel' : ReceivedFilesPanel//,
     //ReceivedFilesPage,
     //UploadFilePage
    }
 })


// WEBPACK FOOTER //
// ./src/main.js